import HeaderContainer from "components/Header/_Header.container";
import Terms from "components/Terms";
import { useRef } from "react";
import { useRouter } from "src/hooks/useRouter";

const TermsPage: React.FC = () => {
  const { goLogin } = useRouter();
  const headerRef = useRef<HTMLDivElement>(null);
  return (
    <>
      {/* <HeaderContainer headerRef={headerRef}></HeaderContainer> */}
      <div>
        <div className="top">
          {/* <a onClick={goLogin}>
            <div className="icon_fasoo main" />
          </a> */}
        </div>
      </div>
      {/* <div style={{ background: "#f5f7fa" }}> */}
      <div style={{ width: "90%", margin: "auto" }}>
        <Terms></Terms>
      </div>
      {/* </div> */}
    </>
  );
};

export default TermsPage;
